import { useEffect } from 'react';
import { useLanguage } from '@/hooks/useLanguage';

const CHATBOT_IDS: Record<string, string> = {
  de: '8vA1SX4GmP',
  en: 'utJnl5EvW1',
};

const CHATBOT_SCRIPT_ID = 'chathero-widget-script';
const CHATBOT_SCRIPT_SRC = 'https://app.chathero.ai/scripts/chathero-2.0.0.js';

const ChatheroChatbot = () => {
  const { language } = useLanguage();
  const botId = CHATBOT_IDS[language];

  useEffect(() => {
    // Remove existing chatbot elements on language change
    const existingIframe = document.getElementById('ChatheroChatbot');
    if (existingIframe) existingIframe.remove();

    // Inject iframe
    const iframe = document.createElement('iframe');
    iframe.id = 'ChatheroChatbot';
    iframe.src = `https://bot.chathero.ai/app/${botId}`;
    iframe.style.cssText = 'position:fixed;z-index:2147483647;bottom:0px;right:0;width:0;height:0;background:none;';
    iframe.setAttribute('frameborder', '0');
    document.body.appendChild(iframe);

    // Inject the global widget controller once. Re-injecting it can redeclare
    // global constants in the third-party script and leave the widget unusable.
    if (!document.getElementById(CHATBOT_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = CHATBOT_SCRIPT_ID;
      script.src = CHATBOT_SCRIPT_SRC;
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      iframe.remove();
    };
  }, [botId]);

  return null;
};

export default ChatheroChatbot;
